import UsageBlockAdmin from './views/UsageBlock.c';
export default UsageBlockAdmin;
